<!-- @format -->

<ng-container *transloco="let t">
  <fudis-expandable [title]="t('FREE_EDIT.MODULE_EXPANDABLE.TITLE')" [level]="2" [closed]="false">
    <ng-template fudisExpandableContent>
      <fudis-section [title]="t('FREE_EDIT.MODULE_EXPANDABLE.ADD_MODULES')" [level]="3">
        <fudis-section-content>
          <label for="add_module">{{ t("FREE_EDIT.MODULE_EXPANDABLE.SEARCH_MODULES_LABEL") }}</label>
          <sis-typeahead
            id="add_module"
            (selectItem)="selectModule.emit($event.item)"
            [typeahead]="doSearch.bind(this)"
            [placeholder]="t('FREE_EDIT.MODULE_EXPANDABLE.SEARCH_MODULES_PLACEHOLDER')"
            [resultTemplate]="moduleSearchTemplate">
          </sis-typeahead>
          <p class="help-block">{{ t("FREE_EDIT.MODULE_EXPANDABLE.SEARCH_MODULES_HELP_TEXT") }}</p>
          @for (module of selectedModules(); track module.id) {
            <ng-container
              *ngTemplateOutlet="moduleBoxes; context: { $implicit: module, planStateObject: planStateObject(), planData: planData() }">
            </ng-container>
          }
        </fudis-section-content>
      </fudis-section>
      <fudis-section [title]="t('FREE_EDIT.MODULE_EXPANDABLE.ADD_UNPLANNED_MODULES_TITLE')" [level]="3" class="sis-pt-md">
        <fudis-section-content>
          @let umas = unplannedModuleAttainments();
          @let ucmas = unplannedCustomModuleAttainments();
          @if (umas.length > 0 || ucmas.length > 0) {
            @for (moduleAttainment of umas; track moduleAttainment.id) {
              @let module = moduleAttainment.moduleId | module | async;
              @if (module) {
                <ng-container
                  *ngTemplateOutlet="moduleBoxes; context: { $implicit: module, planStateObject: planStateObject(), planData: planData() }">
                </ng-container>
              }
            }
            @for (customModuleAttainment of ucmas; track customModuleAttainment.id) {
              @let isInPlan = validatablePlan().isModuleAttainmentInPlan(customModuleAttainment.id);
              <div class="sis-pt-sm">
                <sis-plan-structure-custom-module-attainment-box
                  [customModuleAttainment]="customModuleAttainment"
                  [planStateObject]="planStateObject()"
                  [headingLevel]="4"
                  [action]="'select-to-plan'"
                  [selected]="isInPlan"
                  (actionChange)="
                    toggleCustomModule.emit({
                      customModuleAttainment,
                      isInPlan,
                    })
                  ">
                </sis-plan-structure-custom-module-attainment-box>
              </div>
            }
          } @else {
            <fudis-body-text>{{ t("FREE_EDIT.MODULE_EXPANDABLE.NO_UNPLANNED_MODULES") }}</fudis-body-text>
          }
        </fudis-section-content>
      </fudis-section>
      <fudis-section [title]="t('FREE_EDIT.MODULE_EXPANDABLE.SAVED_MODULES_TITLE')" [level]="3" class="sis-pt-md">
        <fudis-section-content>
          @let modules = savedModules();
          @let customModules = savedCustomModuleAttainments();
          @if (modules.length > 0 || customModules.length > 0) {
            @for (savedModule of modules; track savedModule.id) {
              <ng-container
                *ngTemplateOutlet="
                  moduleBoxes;
                  context: { $implicit: savedModule, planStateObject: planStateObject(), planData: planData() }
                ">
              </ng-container>
            }
            @for (customModuleAttainment of customModules; track customModuleAttainment.id) {
              @let isInPlan = validatablePlan().isModuleAttainmentInPlan(customModuleAttainment.id);
              <div class="sis-pt-sm">
                <sis-plan-structure-custom-module-attainment-box
                  [customModuleAttainment]="customModuleAttainment"
                  [planStateObject]="planStateObject()"
                  [headingLevel]="4"
                  [action]="'select-to-plan'"
                  [selected]="isInPlan"
                  (actionChange)="
                    toggleCustomModule.emit({
                      customModuleAttainment,
                      isInPlan,
                    })
                  ">
                </sis-plan-structure-custom-module-attainment-box>
              </div>
            }
          } @else {
            <fudis-body-text>{{ t("FREE_EDIT.MODULE_EXPANDABLE.NO_SAVED_MODULES") }}</fudis-body-text>
          }
        </fudis-section-content>
      </fudis-section>
    </ng-template>
  </fudis-expandable>

  <ng-template #moduleSearchTemplate let-result="result">
    <div class="module-search__label">
      <p class="module-search__label__main">
        <span>{{ result.name }}</span>
        @if (result?.credits) {
          <span>{{ " (" + (result.credits | creditRange) + ")" }}</span>
        }
      </p>
      <p class="module-search__label__sub">{{ result.code }} | {{ t("FREE_EDIT.MODULE_EXPANDABLE.MODULE") }}</p>
    </div>
  </ng-template>

  <ng-template #moduleBoxes let-module let-planStateObject="planStateObject" let-planData="planData">
    @let isInPlan = validatablePlan().isModuleInPlan(module.id);
    @if (isGroupingModule(module)) {
      <div class="sis-pt-sm">
        <sis-plan-structure-grouping-module-box
          [module]="module"
          [action]="'select-to-plan'"
          [selected]="isInPlan"
          [inputType]="'checkbox'"
          (actionChange)="
            toggleModule.emit({
              module: module,
              isInPlan: isInPlan,
            })
          " />
      </div>
    }
    @if (isStudyModule(module)) {
      <div class="sis-pt-sm">
        <sis-plan-structure-study-module-box
          [module]="module"
          [planStateObject]="planStateObject"
          [planData]="planData"
          [headingLevel]="4"
          [action]="'select-to-plan'"
          [selected]="isInPlan"
          (actionChange)="
            toggleModule.emit({
              module: module,
              isInPlan: isInPlan,
            })
          ">
        </sis-plan-structure-study-module-box>
      </div>
    }
  </ng-template>
</ng-container>
